export const PaymentFieldTypes = {
  CARD_NUMBER: 'card_number',
  EXPIRATION_DATE: 'expiration_date',
  CVC: 'cvc',
  ZIP_CODE: 'zip_code'
};

export const DEFAULT_CARD_FIELD_STATE = {
  isEmpty: true,
  isFocused: false,
  error: null as null | string
};

export const DEFAULT_CARD_FIELD_STATES = {
  CARD_NUMBER: { ...DEFAULT_CARD_FIELD_STATE },
  CARD_CVV: { ...DEFAULT_CARD_FIELD_STATE },
  CARD_DATE: { ...DEFAULT_CARD_FIELD_STATE },
  CARD_POSTAL_CODE: { ...DEFAULT_CARD_FIELD_STATE }
};
